/* eslint-disable no-underscore-dangle */
var ezdia;
(function (ezdia) {
    var lists = '';
    var name = null;
    var inputtab = null;
    function getData(data) {
        var obj;
        if (data && !data.ERROR) {
            $.each(data.Brief, function each(i, brief) {
                obj = brief;
            });
        }
        return obj;
    }
    function getUpdateData(value) {
        var obj;
        var query = {
            brief: {
                name: encodeURIComponent(value)
            }
        };
        var data = checkItemMetaInfo(query);
        if (data && !data.brief.ERROR) {
            $.each(data.brief.Brief, function each(i, brief) {
                obj = brief;
            });
        }
        return obj;
    }
    function getList(briefList) {
        $.each(briefList, function each(i, list) {
            lists = list;
        });
        return lists;
    }
    function getColModel() {
        var col = $.ezdia.config.creativeBriefCol || '';
        if (!col) {
            $.ajax({
                type: 'POST',
                async: false,
                url: 'CreativeBriefCol.htm?formtype=creative_brief',
                dataType: 'json',
                success: function (response) {
                    col = response;
                },
                error: function () {
                    // console.log('error');
                }
            });
            $.ezdia.config.creativeBriefCol = col;
        }
        return col;
    }
    function formatListData(json) {
        var arr = [];
        if (!json) {
            return arr;
        }
        var obj = $.ezdia.getJsonObject(json);
        $.each(obj, function each(key, mval) {
            if (typeof mval === 'object') {
                // eslint-disable-next-line no-param-reassign
                mval = mval.value;
            }
            arr.push({
                li: mval
            });
        });
        return arr;
    }
    function renderData(value, update) {
        var data = update ? getUpdateData(value) : getData(value);
        var column = getColModel();
        var context = {};
        if (data) {
            $.each(column, function eachcolumn(i, col) {
                // eslint-disable-next-line consistent-return
                $.each(data, function each(key, mval) {
                    if (col.name === key) {
                        if (col.edittype === 'inputtab') {
                            inputtab = mval;
                        }
                        else {
                            // eslint-disable-next-line no-param-reassign
                            mval = col.edittype === 'inputlist' ? formatListData(mval) : mval;
                            context[key] = {
                                label: col.label,
                                value: mval
                            };
                        }
                        return false;
                    }
                });
            });
        }
        if (!$.isEmptyObject(inputtab)) {
            inputtab = $.ezdia.getJsonObject(inputtab);
        }
        return context;
    }
    function setOptions(options) {
        var elem = $.data(document, "ez.brief." + options.key) ||
            $.data(document, "ez.brief." + options.key, {});
        elem.key = options.key;
        elem.value = options.value;
        elem.editable = options.editable;
        elem.tab = options.tab;
    }
    function getTabContent(data, obj) {
        var template = $.ezdia.template.get('creative-brief-tab-wrapper');
        var suffix = "ez-creative-brief-" + name;
        var count = 0;
        var context = {
            id: suffix,
            preview: obj.preview,
            empty: obj.empty,
            btn: [
                {
                    label: 'Creative brief',
                    name: suffix,
                    id: "#" + suffix + count,
                    active: 'active'
                }
            ],
            tabs: [
                {
                    id: suffix + count,
                    data: data,
                    active: 'active'
                }
            ]
        };
        count += 1;
        if (inputtab && inputtab.length) {
            $.each(inputtab, function each(i, objs) {
                context.btn.push({
                    label: objs.tab_name || 'Creative brief tab',
                    name: suffix,
                    id: "#" + suffix + count
                });
                context.tabs.push({
                    id: suffix + count,
                    data: objs.tab_content
                });
                count += 1;
            });
        }
        return template(context);
    }
    function getContext(data, obj) {
        var context = getTabContent(data, obj);
        return context;
    }
    function enableEdit() {
        $('#ez-brief-readonly-name')
            .hide()
            .closest('[data-content="creative brief"]')
            .addClass('editable');
        $('#ez-brief-edit-name, #ez-edit-brief-btn-cancel').show();
    }
    function cancelEdit() {
        $('#ez-brief-readonly-name')
            .show()
            .closest('[data-content="creative brief"]')
            .removeClass('editable');
        $('#ez-brief-edit-name, #ez-edit-brief-btn-cancel').hide();
    }
    // eslint-disable-next-line import/prefer-default-export
    ezdia.creativeBrief = {
        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
        init: function (initObj, obj) {
            if (!initObj._fields) {
                initObj._fields = {};
            }
            initObj._fields[obj.name || obj.key] = obj;
            initObj.value = obj.value;
        },
        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
        create: function (briefObj) {
            inputtab = {};
            var pageParams = $.ezdia.config.pageParams;
            var self = this;
            var content = '';
            if (!briefObj._fields) {
                return;
            }
            $.each(briefObj._fields, function each(key, options) {
                var values = '';
                var brief = '';
                if (!options.update) {
                    setOptions(options);
                    values = briefObj._value || ezdia.config.metadata.brief;
                }
                else {
                    values = options.value;
                }
                var partial = {
                    editable: 'creative-brief-editable'
                };
                var template = $.ezdia.template.get('creative-brief', partial);
                var context = renderData(values, options.update);
                var isEmpty = $.isEmptyObject(context);
                if (isEmpty && !options.update) {
                    context.empty = true;
                }
                else {
                    context.empty = !!isEmpty;
                }
                name = options.key;
                context.editable = options.editable;
                context.key = options.key;
                context.name = options.name || options.key;
                context.value = options.value;
                context.tab = options.tab;
                context.preview = options.preview;
                if (options.editable) {
                    lists = getList(pageParams.briefList || {});
                    if (!options.update) {
                        $('body')
                            .off('.ez.updateBrrief')
                            .on('click.ez.updateBrrief', '#ez-edit-briefname-update', $.proxy(self.update, self))
                            .on('click.ez.updateBrrief', '#ez-edit-brief-name', enableEdit)
                            .on('click.ez.updateBrrief', '#ez-edit-brief-btn-cancel', cancelEdit);
                    }
                }
                brief = template(context);
                content = getContext(brief, context);
                if (!options.tab && !options.update && !options.preview) {
                    $("[name= " + (options.name || options.key) + "]").replaceWith(content);
                    $('#ez_js_sys_creative_brief_tab').scrollingNav({
                        tabs: true
                    });
                    if (options.editable) {
                        $.ezdia.typehead.create([
                            {
                                id: options.key,
                                metadata: lists,
                                column: { editable: options.editable }
                            }
                        ]);
                    }
                }
            });
            if (content) {
                // eslint-disable-next-line consistent-return
                return content;
            }
        },
        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
        save: function (form, btn) {
            $("#" + form)
                .ajaxForm({
                success: function (response) {
                    btn.button('reset');
                    $.ezdia.successMsg(response);
                    $("#" + form).hide();
                    $('#grid').trigger('reloadGrid');
                },
                error: function (response) {
                    btn.button('reset');
                    $.ezdia.successMsg(response, true);
                }
            })
                .submit();
        },
        update: function (e) {
            var elem = $(e.currentTarget);
            var key = elem.data('key');
            var names = elem.data('name');
            var value = $("#" + key).val();
            var obj = $.data(document, "ez.brief." + key);
            var options = [];
            var briefObj = {
                _fields: {}
            };
            briefObj._fields[names || key] = {
                key: key,
                name: names || key,
                value: value,
                editable: obj.editable,
                grouptypeArray: options,
                tab: obj.tab,
                update: true
            };
            var data = this.create(briefObj);
            $("#ez-creative-brief-" + name).replaceWith(data);
            $.ezdia.typehead.update([
                { id: key, metadata: lists, column: { editable: true } }
            ]);
            $('#ez_js_sys_creative_brief_tab').scrollingNav({
                tabs: true
            });
        },
        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
        setValue: function (obj) {
            var attName = obj.element.attr('name');
            var btn = $("#ez-creative-brief-" + attName).find("button[data-name=" + attName + "]");
            obj.element.val(obj.value);
            btn.trigger('click');
        },
        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
        delValue: function (obj) {
            var id = obj.element.attr('id');
            var wrapper = $("#ez-creative-brief-" + name);
            var updateBtn = wrapper.find("button[data-name=" + name + "]");
            var editLink = wrapper.find("a[data-name=" + name + "]");
            $.ezdia.typehead.toggle(id, obj.action);
            if (obj.action) {
                updateBtn.attr('disabled', 'disabled');
                editLink.hide();
            }
            else {
                updateBtn.removeAttr('disabled');
                editLink.show();
            }
        }
    };
    /**
     * This line of code for support old code.
     * It should be removed in future
     */
    $.ezdia.creativeBrief = ezdia.creativeBrief;
})(ezdia || (ezdia = {}));
